import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function GradjanskoProcesnoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Građansko procesno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Građansko procesno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Građansko procesno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong> Đuro Đurić
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Građansko procesno pravo je upoznavanje studenata
                sa osnovnim pojmovima i načelima građansko procesnog prava
                organizacijom sudova u Crnoj Gori ulogom drugih pravosudnih
                organa u parničnom vanparničnom i izvršnom postupku. Studenti
                stiču teorijska i praktična znanja o pravilima postupka na
                osnovu kojih sudovi raspravljaju i odlučuju u građanskopravnim
                sporovima. Takođe i povezivanje znanja iz ostalih materijalno
                pravnih oblasti sa procesnim normama radi ostvarivanja prava u
                parničnom vanparničnom i izvršnom postupku. CIlj ovog predmeta
                je i upoznati studente sa sudskom praksom.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon polaganja ispita student će biti u mogućnosti da: definiše
                i objasni pojmove građansko procesnog prava kao i da ih uporedi
                sa pojmovima krivično procesnog prava; razlikuje parnični od
                krivičnog i upravno procesnog postupka; razliku građansko
                procesno pravo od građanskog prava; razlikuje i objasni
                pravosudne organe i njihovu organizaciju; imenuje i definiše
                subjekte parničnog postupka i objasni parničnu i procesnu
                sposobnost stranaka; objasni i opiše tok parničnog postupka;
                objasni i opiše drugostepeni parnični postupak; objasni i opiše
                postupak po vanrednim pravnim ljekovima; objasni i opiše
                vanparnični i izvršni postupak; objasni alternativne načine
                rješavanja sporova; razvije sposobnost tumačenja i primjene
                pravila Građansko procesnog prava u konkretnim slučajevima kao i
                kritiĉke analize stavova i rješavanja problema.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
                Pojam cilj predmet i pravna priroda parničnog postupka; Izvori
                građansko procesnog prava; Odnos parničnog postupka i drugih
                postupaka; Načela parničnog procesnog prava i postupka; Subjekti
                parničnog postupka; Organizacija sudova; Isključenje i izuzeće
                sudija; Nadležnost sudova; Parnične stranke; Parnička i
                stranačka sposobnost; Treća lica u parnici; Zastupnici stranaka;
                Parnične radnje; Rokovi povraćaj u pređašnje stanje; Mirno
                rješavanje sporova u toku parnice i alternativne metode
                rješavanja sporova; Tužba I odgovor na tužbu; Postupak pred
                prvostepenim sudom; Pripremno ročište glavna rasprava; Prethodno
                pitanje; Zastoj i prekid postupka; Dokazivanje i dokazna
                sredstva; Sudsko poravnanje; Vrste odluka; Redovni pravni
                ljekovi; Vanredni pravni ljekovi; Pravosnažnost odluke; Troškovi
                postupka; Posebni parnični postupci; Medijacija; Vanparnični
                postupak: pojamcil načela I subjekti; Posebni vanparnični
                postupci; Izvršni postupak: pojam predmet I karakteristike;
                Vrste izvršenja; Posebni postupci izvršenja i privremene mjere
              </p>
              <p>
                <strong>Praktična nastava:</strong>
                Praktična nastava se obavlja na predavanjima i vježbama kroz
                upoznavanje sa sudskom praksom i njenom analizom od strane
                studenata. Takođe studenti će kroz posjetu sudovima i
                neposrednim pracenjem suđenja bliže se upoznati sa samim tokom
                postupka kao i radnjama suda i stranaka. Na fakultetu će se
                organizovati predavanja eminentnih stručnjaka (sudija advokata
                notara) kako bi studentima približili kako pravosuđe funckioniše
                i kako bi ih upoznali sa slučajevima iz prakse koja je vrlo
                bogata.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava se izvodi kroz predavanja, diskusije, izrade samostalnih
                istraživačkih radova – seminarskih radova, upoznavanje sa
                sudskom praksom crnogorskih sudova (u sudu ili u okviru nastave
                na fakultetu) i analizu sudske prakse od strane studenata.
              </p>
              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 2V</td>
                    <td>
                      Pojam cilj predmet i pravna priroda parničnog postupka;
                      Izvori građansko procesnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 2V</td>
                    <td>
                      Odnos parničnog postupka i drugih postupaka; Načela
                      parničnog procesnog prava i postupka
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 2V</td>
                    <td>
                      Subjekti parničnog postupka; Organizacija sudova;
                      Isključenje i izuzeće sudija; Nadležnost sudova
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 2V</td>
                    <td>
                      Parnične stranke; Parnička i stranačka sposobnost; Treća
                      lica u parnici; Zastupnici stranaka; + Praktična nastava.
                      Predavanje gostujućih predavača.
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 2V</td>
                    <td>
                      Parnične radnje; Rokovi i povraćaj u pređašnje stanje;
                      Mirno rješavanje sporova u toku parnice i alternativne
                      metode rješavanja sporova + Praktična nastava.
                      Prisustvovanje suđenju. Analiza sudske prakse.
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 2V</td>
                    <td>Postupak pred prvostepenim sudom</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Pripremno ročište glavna rasprava; Prethodno pitanje +
                      Praktična nastava. Prisustvovanje suđenju.
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 2V</td>
                    <td>
                      Zastoj i prekid postupka; Dokazivanje i dokazna sredstva;
                      Sudsko poravnanje
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 2V</td>
                    <td>Vrste odluka</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 2V</td>
                    <td>
                      Redovni pravni ljekovi; Vanredni pravni ljekovi;
                      Pravosnažnost odluke; Troškovi postupka + Praktična
                      nastava. Prisustvovanje suđenju. Analiza sudske prakse.
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 2V</td>
                    <td>
                      Posebni parnični postupci; Medijacija + Posjeta Centru za
                      posredovanje. Analiza sudske prakse.
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 2V</td>
                    <td>
                      Vanparnični postupak: pojamcil načela I subjekti; Posebni
                      vanparnični postupci
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 2V</td>
                    <td>
                      Izvršni postupak: pojam predmet I karakteristike; Vrste
                      izvršenja; Posebni postupci izvršenja i privremene mjere +
                      Praktična nastava. Prisustvovanje suđenju. Pisanje
                      podnesaka presuda i ostalih pismena.
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 6 č / 4.3h</td>
                            <td>Ukupno: 120 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3h</td>
                            <td>Nastava + završni ispit: 90 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 9 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 21 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default GradjanskoProcesnoPravo;
